// extracted by mini-css-extract-plugin
export default {"searchBoxContainer":"SearchBox_searchBoxContainer__0dV0V","noResultsDropdown":"SearchBox_noResultsDropdown__owA4k"};